export default "__VITE_ASSET__DqVyYvKi__"